/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Entry } from '../model/entry';
import { GetAttributeListResponse } from '../model/getAttributeListResponse';
import { GetAttributeResponse } from '../model/getAttributeResponse';
import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { SettingsServiceInterface }                            from './settings.serviceInterface';


@Injectable()
export class SettingsService implements SettingsServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param departmentId 
     * @param appId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAttributeResponse>;
    public getDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAttributeResponse>>;
    public getDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAttributeResponse>>;
    public getDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getDepartmentAttribute1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAttributeResponse>(`${this.basePath}/settings/department/${encodeURIComponent(String(key))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param departmentId 
     * @param appId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAttributeListResponse>;
    public getDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAttributeListResponse>>;
    public getDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAttributeListResponse>>;
    public getDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getDepartmentAttributeList1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAttributeListResponse>(`${this.basePath}/settings/deplist/${encodeURIComponent(String(key))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param login 
     * @param appId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserAttribute1(key: string, organization?: string, login?: string, appId?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAttributeResponse>;
    public getUserAttribute1(key: string, organization?: string, login?: string, appId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAttributeResponse>>;
    public getUserAttribute1(key: string, organization?: string, login?: string, appId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAttributeResponse>>;
    public getUserAttribute1(key: string, organization?: string, login?: string, appId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getUserAttribute1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAttributeResponse>(`${this.basePath}/settings/user/${encodeURIComponent(String(key))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param login 
     * @param appId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAttributeListResponse>;
    public getUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAttributeListResponse>>;
    public getUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAttributeListResponse>>;
    public getUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getUserAttributeList1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAttributeListResponse>(`${this.basePath}/settings/userlist/${encodeURIComponent(String(key))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param departmentId 
     * @param appId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setDepartmentAttribute1(key: string, organization?: string, departmentId?: number, appId?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling setDepartmentAttribute1.');
        }





        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/settings/department/${encodeURIComponent(String(key))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param departmentId 
     * @param appId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, body?: Array<Entry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, body?: Array<Entry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, body?: Array<Entry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setDepartmentAttributeList1(key: string, organization?: string, departmentId?: number, appId?: string, body?: Array<Entry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling setDepartmentAttributeList1.');
        }





        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/settings/deplist/${encodeURIComponent(String(key))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param login 
     * @param appId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setUserAttribute1(key: string, organization?: string, login?: string, appId?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setUserAttribute1(key: string, organization?: string, login?: string, appId?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setUserAttribute1(key: string, organization?: string, login?: string, appId?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setUserAttribute1(key: string, organization?: string, login?: string, appId?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling setUserAttribute1.');
        }





        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/settings/user/${encodeURIComponent(String(key))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param key 
     * @param organization 
     * @param login 
     * @param appId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, body?: Array<Entry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, body?: Array<Entry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, body?: Array<Entry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setUserAttributeList1(key: string, organization?: string, login?: string, appId?: string, body?: Array<Entry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling setUserAttributeList1.');
        }





        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }
        if (appId !== undefined && appId !== null) {
            headers = headers.set('appId', String(appId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/settings/userlist/${encodeURIComponent(String(key))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
